<template>
    <div>
        <div class="form-group">
            <input 
                type="text"
                :value="currentUrl"
                readonly>
            <button 
                class="btn btn-sm btn-dark"
                v-clipboard:copy="currentUrl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >คัดลอก</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentUrl: "",

            message: "",
            copiedText: "",
        }
    },
    created() {
        this.currentUrl = window.location.href;
    },
    methods: {
        onCopy: function (e) {
            this.copiedText = e.text;
        },
        onError: function (e) {
            console.log('Failed to copy texts')
        },
    }
}
</script>